import React, { forwardRef } from "react";
import PropTypes from "kf-proptypes/widgets";

import styles from "./tab.css";

export const ROUND_TABS_SIZE = {
  MEDIUM: "medium",
  SMALL: "small",
  MEDIUM_DEPRECATED: "mediumDepreacted"
};

RoundTabsComponent.propTypes = {
  /** A list of RoundTab components.  */
  children: PropTypes.node.isRequired,
  /** The id of the currently visible tab pane. */
  activeTabId: PropTypes.string.isRequired,
  /** A callback function that gets invoked when the tabs. */
  onChange: PropTypes.func.isRequired,
  /** To override the existing styles of the component */
  className: PropTypes.string,
  /** Different variant in chip tab */
  size: PropTypes.oneOf(Object.values(ROUND_TABS_SIZE))
};

function RoundTabsComponent(props, ref) {
  const {
    children,
    activeTabId,
    onChange,
    className = "",
    size = ROUND_TABS_SIZE.MEDIUM
  } = props;
  return (
    <div
      className={`${styles.roundtabs} ${styles[size]} ${className}`}
      ref={ref}
    >
      {children.map(
        (child) =>
          child && (
            <button
              key={child.props.tabId}
              className={`${
                child.props.tabId === activeTabId ? styles.active : ""
              }`}
              onClick={() => {
                onChange(child.props.tabId);
              }}
              {...child.props}
            >
              {child.props.children}
            </button>
          )
      )}
    </div>
  );
}

export const RoundTabs = forwardRef(RoundTabsComponent);

RoundTabs.propTypes = {
  /** A list of RoundTab components.  */
  children: PropTypes.node,
  /** The id of the currently visible tab pane. */
  activeTabId: PropTypes.string,
  /** A callback function that gets invoked when the tabs. */
  onChange: PropTypes.func,
  /** To override the existing styles of the component */
  className: PropTypes.string,
  /** Different variant in chip tab */
  size: PropTypes.string
};

export function RoundTab(props) {
  const { children } = props;
  return children;
}

RoundTab.propTypes = {
  children: PropTypes.node,
  tabId: PropTypes.string
};
